<template>
  <el-dialog
    title="发票信息"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="发票抬头" prop="title">
        <el-input
          size="small"
          v-model="model.title"
          placeholder="发票抬头"
        ></el-input>
      </el-form-item>
      <el-form-item label="纳税识别号">
        <el-input
          size="small"
          v-model="model.tax_number"
          placeholder="纳税识别号"
        ></el-input>
      </el-form-item>
      <el-form-item label="开户行">
        <el-input
          size="small"
          v-model="model.bank_name"
          placeholder="开户行"
        ></el-input>
      </el-form-item>
      <el-form-item label="银行账号">
        <el-input
          size="small"
          v-model="model.bank_account"
          placeholder="银行账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input
          size="small"
          v-model="model.address"
          placeholder="地址"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="代理人">
        <el-input
          size="small"
          v-model="model.contact"
          placeholder="代理人"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理人电话">
        <el-input
          size="small"
          v-model="model.contact_phone"
          placeholder="代理人电话"
        ></el-input>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { createDealerInvoice } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
      },
      submiting: false,
    }
  },
  created() {},
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await createDealerInvoice(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>